
import { Input } from "@/components/ui/input";

interface EmailInputProps {
  email: string;
  isLoading: boolean;
  onChange: (value: string) => void;
}

export function EmailInput({ email, isLoading, onChange }: EmailInputProps) {
  return (
    <div>
      <Input
        type="email"
        placeholder="name@example.com"
        value={email}
        onChange={(e) => onChange(e.target.value)}
        required
        disabled={isLoading}
        className="h-11 py-1.5 text-base rounded-md"
      />
    </div>
  );
}
